/* eslint-disable */
/**
 * Google Analytics
 */
export default class Analytics {

  /**
   * Output the Google Tag Manager script.
   */
  gtm() {
    (function(w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({
        'gtm.start': new Date().getTime(), event: 'gtm.js'
      });
      const f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
      j.async = true;
      j.src = `https://www.googletagmanager.com/gtm.js?id=${i}${dl}&gtm_auth=${window.analytics.environAuth}&gtm_preview=${window.analytics.environPreview}&gtm_cookies_win=x`;
      f.parentNode.insertBefore(j, f);
    })(window, document, 'script', window.analytics.dataLayer, window.analytics.containerKey);
  }
}
